import React from 'react';
import { Box, Tooltip } from '@mui/joy';

type AlphaTagProps = {
  collapsed?: boolean;
};

export const AlphaTag: React.FC<AlphaTagProps> = ({ collapsed = false }) => {
  return (
    <Tooltip
      title="Versão Alpha - Primeira versão do software. Bugs e instabilidades podem ocorrer."
      placement={collapsed ? "right" : "bottom"}
      sx={{
        zIndex: 10002,
        '& .MuiTooltip-tooltip': {
          maxWidth: 300,
          fontSize: '0.75rem',
          fontWeight: 400,
          bgcolor: 'background.popup',
          border: '1px solid',
          borderColor: 'divider',
          boxShadow: 'lg',
        }
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          bottom: collapsed ? -2 : -5,
          right: collapsed ? -4 : -3,
          fontSize: collapsed ? '0.4rem' : '0.42rem',
          fontWeight: 600,
          fontFamily: 'Inter, sans-serif',
          letterSpacing: '0.02em',
          padding: collapsed ? '0.5px 2px' : '1px 2.5px',
          borderRadius: '2px',
          background: 'linear-gradient(135deg, #FFD700 0%, #FFA500 50%, #FF8C00 100%)',
          color: '#2c1810',
          textShadow: '0 0.5px 1px rgba(255,255,255,0.3)',
          boxShadow: '0 1px 2px rgba(0,0,0,0.2), inset 0 0.5px 0 rgba(255,255,255,0.3)',
          cursor: 'help',
          userSelect: 'none',
          transform: 'translateZ(0)',
          transition: 'all 0.2s ease',
          zIndex: 100,
          '&:hover': {
            transform: 'translateZ(0) scale(1.05)',
            boxShadow: '0 1px 3px rgba(0,0,0,0.3), inset 0 0.5px 0 rgba(255,255,255,0.4)',
          }
        }}
      >
        ALPHA
      </Box>
    </Tooltip>
  );
};

export default AlphaTag; 